module.exports = __webpack_public_path__ + "static/media/icon-how-it-works1.d1c72bb4.svg";